



























































































































































































































































































































































































import ReportStageDetails from './scripts';
export default ReportStageDetails;
